import { Link } from "react-router-dom";

type Prop = {
    to? : string,
    imgUrl? : string,
    title? : string,
    location? : string,
}

const BusinessCard = ({
        to = '/', 
        imgUrl = 'https://via.placeholder.com/300.png/888/fff', 
        location = 'unknown', 
        title = 'untitled'
    }:Prop)=>{
    return (
        <Link to={to} className="block w-full relative h-64 md:h-44 overflow-hidden group rounded-md">
            <img src={imgUrl} className="absolute top-0 left-0 w-full h-full object-cover z-[-2] group-hover:scale-110 transition" alt="" />
            <div className="absolute top-0 w-full h-full z-[-1] bg-black opacity-20"></div>
            <div className="absolute bottom-0 left-0 p-2">
                <span className="text-white font-semibold">{title}</span>
            </div>
        </Link>
    )
}

export default BusinessCard;